// Auth
export const LOGIN = "/admin/adminLogin";
export const FORGOT = "/admin/adminForgetPassword";
export const VERIFY_OTP = "/admin/adminVerifyOtp";
export const RESET = "/admin/resetAdminPassword";
export const CHANGE_PASSWORD = "/admin/changeAdminPassword";
export const UPDATE_FCM_TOKEN = "/user/updateFcmToken";

// Category
export const GET_CATEGORY = "/category/categoryListing";
export const CREATE_CATEGORY = "/category/add";
export const UPDATE_CATEGORY = "/category/edit/";
export const DELETE_CATEGORY = "/category/delete/";

// Genres
export const GET_GENRES = "/genre/list";
export const CREATE_GENRES = "/genre/add";
export const UPDATE_GENRES = "/genre/edit/";
export const DELETE_GENRES = "/genre/delete/";

// Artist endpoints
export const CREATE_ARTIST = "/artist/createArtist";
export const UPDATE_ARTIST = "/artist/updateArtist";
export const DELETE_ARTIST = "/artist/deleteArtist";
export const GET_ALL_ARTIST = "/artist/getAllArtist";

// User management
export const GET_USER = "/user/getAllUsers";
export const ENABLE_DISBLED_USER = "user/activeInactiveUser";
export const DELETE_USER = "/user/deleteUser/";
export const CURRENT_BOOKING = "/order/currentBooking/";
export const PAST_BOOKING = "/order/pastBooking/";

// event management

export const CURRENT_EVENTS = "/event/currentEvents";
/** Club-scoped listing for staff: GET ?clubid= */
export const EVENT_LIST = "/event/list";
export const PAST_EVENTS = "/event/pastEvents";
export const ADD_EVENT = "/event/add";
export const UPLOAD_EVENT_IMAGE = "/event/uploadImage";
export const SOLDOUTEVENT = "/event/soldOutEvent/";
export const EDIT_EVENT = "/event/update/";
export const DELETE_EVENT = "/event/deleteEvent/";
export const CANCEL_EVENT = "/event/cancelEvent/";
export const EVENT_DETAILS = "/event/eventDetails/";
export const EVENT_TICKET_STATUS = "/event/ticketStatusByEvent/";
export const EVENT_INQUEUE_USERS = "event/queueStatus/";

// language management

export const GET_LANGUAGE = "/lan/list";

//organiser

export const GET_ORGANISER = "/organiser/list";
export const CREATE_ORGANISER = "/organiser/create";
export const DELETE_ORGANISER = "/organiser/delete/";
export const DELETE_ORGANISER_IT_SELF = "/organiser/delete";

export const ACTIVE_INACTIVE_ORGANISER = "/organiser/activeInactive/";
export const RESEND_INVITE_ORGANISER = "/organiser/resend-invite/";
export const LISTOF_PAST_EVENT_BY_ORGANISER = "/event/pastEvents";
export const LISTOF_CURRENT_EVENT_BY_ORGANISER = "/event/currentEvents";
export const SET_ORGANISER_PASSWORD = "/organiser/set-password";

// Clubs (admin)
export const CLUB_ADD = "/club/add";
export const CLUB_UPDATE = "/club/update/";
export const CLUB_LIST = "/club/list";
export const CLUB_ADMIN = "/club/admin/";
export const CLUB_WEBSITE_UPDATE = "/club/website/";
export const CLUB_MANAGER_INVITE = "/club/manager/invite";
export const CLUB_MANAGER_ACTIVITY = "/club/manager/activity";
export const CLUB_REPORTS_SALES = "/club/reports/sales";
export const CLUB_REPORTS_SALES_BOOKINGS = "/club/reports/sales/bookings";
export const CLUB_REPORTS_SALES_ISSUED_TICKETS =
  "/club/reports/sales/issued-tickets";
export const CLUB_REPORTS_TABLE_BOOKING_LINES =
  "/club/reports/table-bookings/lines";
/** GET/POST /club/reports/event-summary/:eventId/(download|readiness|force-close-device|close) — Auth: ADMIN | CLUB_MANAGER */
export const CLUB_REPORTS_EVENT_SUMMARY_DOWNLOAD =
  "/club/reports/event-summary";
export const CLUB_MANAGERS_FOR_CLUB = "/club/manager/club/";
export const CLUB_PUBLIC_BY_SLUG = "/club/public/";
/** GET /club/public/:slug/book-latest — resolve latest event for print QR /book route (guest). */
export const CLUB_PUBLIC_BOOK_LATEST = (slug) =>
  `/club/public/${encodeURIComponent(slug)}/book-latest`;
/** GET /club/manager/club/:clubId/share-link?target=website|book-latest — Auth: ADMIN | CLUB_MANAGER */
export const CLUB_MANAGER_SHARE_LINK = (clubId) =>
  `/club/manager/club/${clubId}/share-link`;
export const CLUB_EMPLOYEE_INVITE = "/club/employee/invite";
/** POST /club/employee/resend-invite/:userId — Auth: ADMIN | CLUB_MANAGER */
export const CLUB_EMPLOYEE_RESEND_INVITE = "/club/employee/resend-invite/";
/** GET /club/employee/club/:clubId/employees */
export const CLUB_EMPLOYEES_FOR_CLUB = "/club/employee/club/";
export const CLUB_CASHIER_INVITE = "/club/cashier/invite";
/** POST /club/cashier/resend-invite/:userId — Auth: ADMIN | CLUB_MANAGER */
export const CLUB_CASHIER_RESEND_INVITE = "/club/cashier/resend-invite/";
/** GET /club/cashier/club/:clubId/cashiers */
export const CLUB_CASHIERS_FOR_CLUB = "/club/cashier/club/";
/** GET /club/operator/club/:clubId/operators */
export const CLUB_OPERATORS_FOR_CLUB = "/club/operator/club/";
/** POST /club/manager/resend-invite/:userId — Auth: ADMIN */
export const CLUB_MANAGER_RESEND_INVITE = "/club/manager/resend-invite/";
export const ORDER_OFFLINE_SALE = "/order/offlineSale";
/** POST complimentary guestlist tickets — Auth: ADMIN | CLUB_MANAGER only */
export const ORDER_GUESTLIST = "/order/guestlist";
/** GET /order/guestlist/template/:eventId — Excel template download. Auth: CLUB_MANAGER */
export const ORDER_GUESTLIST_TEMPLATE = (eventId) =>
  `/order/guestlist/template/${encodeURIComponent(String(eventId ?? "").trim())}`;
/** POST /order/guestlist/bulk — multipart bulk import. Auth: CLUB_MANAGER */
export const ORDER_GUESTLIST_BULK = "/order/guestlist/bulk";
/** GET /order/viewTicketsGuest/:orderId?token= — no Authorization (64-char hex token). */
export const ORDER_VIEW_TICKETS_GUEST = "/order/viewTicketsGuest/";
/** GET /order/viewTicketsWithTicketId/:orderId — requires Bearer user token. */
export const ORDER_VIEW_TICKETS_WITH_TICKET_ID = "/order/viewTicketsWithTicketId/";
/** GET /order/event/:eventId/bookings?status=&page=&limit= — Auth: ADMIN only. PII-masked. */
export const ORDER_EVENT_BOOKINGS = (eventId) =>
  `/order/event/${eventId}/bookings`;

/** GET/POST /club/:clubId/catalog-items — Auth: ADMIN | CLUB_MANAGER */
export const CLUB_CATALOG_ITEMS = (clubId) =>
  `/club/${encodeURIComponent(String(clubId))}/catalog-items`;
/** PUT /club/:clubId/catalog-items/:itemId */
export const CLUB_CATALOG_ITEM = (clubId, itemId) =>
  `/club/${encodeURIComponent(String(clubId))}/catalog-items/${encodeURIComponent(String(itemId))}`;

/** Admin/club manager table & party-area booking (layouts & bookings). */
export const TABLE_BOOKING_CLUB_LAYOUTS = (clubId) =>
  `/club/table-booking/manager/club/${clubId}/layouts`;
export const TABLE_BOOKING_CLUB_LAYOUT = (clubId, layoutId) =>
  `/club/table-booking/manager/club/${clubId}/layouts/${layoutId}`;
export const TABLE_BOOKING_CLUB_BOOKINGS = (clubId) =>
  `/club/table-booking/manager/club/${clubId}/bookings`;
/** GET — public live table sheet (no auth). slug lowercase. */
export const TABLE_BOOKING_PUBLIC_TABLE_SHEET = (slug) =>
  `/club/table-booking/public/${encodeURIComponent(slug)}/table-sheet`;
/** GET — manager copy-link for public table sheet. Auth: ADMIN | CLUB_MANAGER */
export const TABLE_BOOKING_MANAGER_TABLE_SHEET_SHARE_LINK = (clubId) =>
  `/club/table-booking/manager/club/${clubId}/table-sheet/share-link`;
